import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import { inflateSync, deflateSync } from 'fflate';
function decodeSceneData(sceneData) {
  const step1 = atob(sceneData);
  const step2 = Uint8Array.from(step1, c => c.charCodeAt(0));
  const step3 = inflateSync(step2);
  const step4 = new TextDecoder().decode(step3);
  return JSON.parse(step4);
}
function encodeSceneData(sceneData) {
  const stringifiedSceneData = JSON.stringify(sceneData);
  const encoder = new TextEncoder();
  const encodedValue = encoder.encode(stringifiedSceneData);
  const valueDeflated = deflateSync(encodedValue);
  if (typeof btoa === 'undefined') {
    return Buffer.from(valueDeflated).toString('base64');
  }
  return btoa(String.fromCharCode(...valueDeflated));
}
function getRotatedSceneUrl(sceneUrl) {
  const dynamicSceneUrl = new URL(sceneUrl);
  const sceneData = dynamicSceneUrl.searchParams.get('data');
  const decodedSceneData = decodeSceneData(sceneData);
  if (decodedSceneData['context']['type'] === 'pattern') {
    const {
      width,
      height
    } = decodedSceneData['context']['pattern'];
    decodedSceneData['context']['pattern']['width'] = height;
    decodedSceneData['context']['pattern']['height'] = width;
  }
  decodedSceneData['transforms'] = [{
    target: 'panel',
    type: 'rotate',
    rotate: 90
  }];
  const rotatedSceneData = encodeSceneData(decodedSceneData);
  dynamicSceneUrl.searchParams.set('data', rotatedSceneData);
  return dynamicSceneUrl.toString();
}
function getRotateScene(scene) {
  var _a;
  // Change scene url
  scene.url = getRotatedSceneUrl(scene.url);
  // Change width/height
  const {
    width,
    height
  } = scene.dimensions;
  scene.dimensions.width = height;
  scene.dimensions.height = width;
  (_a = scene.documents) === null || _a === void 0 ? void 0 : _a.forEach(doc => {
    if (doc.bounds) {
      const {
        width: boundsWidth,
        height: boundsHeight,
        x,
        y
      } = doc.bounds;
      doc.bounds.width = boundsHeight;
      doc.bounds.height = boundsWidth;
      doc.bounds.x = y;
      doc.bounds.y = x;
    }
  });
  return scene;
}
export function addLegacyProjectionFix(views) {
  return views.map(view => {
    if (view.type === 'scene' && view.scene.type === 'dynamic' && view.requiresRotation) {
      const clonedView = JSON.parse(JSON.stringify(view));
      clonedView.scene = getRotateScene(view.scene);
      return clonedView;
    }
    if (view.type === 'panel' && view.requiresRotation) {
      const clonedView = JSON.parse(JSON.stringify(view));
      clonedView.panel.aspectRatio = 1 / clonedView.panel.aspectRatio;
      return clonedView;
    }
    return view;
  });
}